import { FETCH_COUPON, RESET_COUPON } from "../../constants/action.constants";

const initialState = {
  data: {},
};

const couponViewReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COUPON:
      return { data: action.payload };
    case RESET_COUPON:
      return initialState;
    default:
      return state;
  }
};

export default couponViewReducer;
